<template>
  <v-container fluid class="user-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/user/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="users-table"
              show-select
              single-select
              item-key="_id"
              sort-by="userstatus"
              :footer-props="footer"
              :headers="headers"
              :items="users"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this User?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteuser.username }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteuser)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.userimage" size="50">
                  <img v-bind:src="item.userimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="50">
                  <span class="white--text headline">{{ item.username[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.roleid="{ item }">
                <p v-if="item.roleid!=null" class="two-line">{{ roles.length>0 ? roles.find(role=>role._id == item.roleid)['rolecode'] : ''  }}</p>
                <p v-if="item.menuid!=null" class="two-line">{{ menus.length>0 && menus.find(menu=>menu._id == item.menuid) ? menus.find(menu=>menu._id == item.menuid)['menucode'] : ''  }}</p>
                <p v-if="item.channelid!=null" class="two-line">{{ saleschannels.length>0 && saleschannels.find(channel=>channel._id == item.channelid) ? saleschannels.find(channel=>channel._id == item.channelid)['channelcode'] : ''  }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p v-if="item.locationid!=null && locations.find(location=>location._id == item.locationid)!=null" class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
                <p class="two-line">{{ item.usertype }}</p>
              </template>
              <template v-slot:item.username="{ item }">
                <p class="two-line"><b>{{ item.username }}</b></p>
                <p class="two-line">{{ item.userid }}</p>
                <p class="two-line"><a class="primaryConst--text">{{ item.useremail }}</a></p>
                <p class="two-line">{{ item.usermobile }}</p>
              </template>
              <template v-slot:item.userstatus="{ item }">
                <v-chip
                  :color="item.userstatus=='Active' ? 'successConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.userstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteuser: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Name', value: 'username' },
        { text: 'Location & Type', value: 'locationid' },
        { text: 'Role, Menu & Channel', value: 'roleid' },
        { text: 'Status', value: 'userstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      switch1: true,
      }
  },
  computed: {
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('Menu', ['menus']),
    ...mapState('Role', ['roles']),
    ...mapState('User', ['users', 'isReceiving', 'isDeleting', 'idToDelete', 'usersMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Menu', ["getMenusRequest"]),
    ...mapActions('Role', ["getRolesRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest","deleteUserRequest","updateUserRequest","createUserRequest"]),
    editItem(item) {
      this.$router.push({ name: 'UserEdit', params: item })
    },
    deleteItem(item) {
      this.deleteUserRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      console.log(item);
      this.dialog = true;
      this.deleteuser = {
        _id: item._id,
        username: item.username,
      }
    },
  },
  async created () {
    await this.getUsersRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.menus.length==0) await this.getMenusRequest();
    if(this.roles.length==0) await this.getRolesRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
